import _toConsumableArray from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/inherits";
import React from 'react';
import { withStyles } from '@material-ui/core';
import Api from '../../api';
import Dialog from '../dialog/Dialog';
import { catchError, map } from 'rxjs/operators';
import styles from './DocumentViewer.style';
import { throwError } from 'rxjs';
/**
 * Декодирование base64 в blob
 * @param b64Data
 * @param contentType
 * @param sliceSize
 */

function b64toBlob(b64Data) {
  var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var sliceSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 512;
  var byteCharacters = atob(b64Data);
  var byteArrays = [];

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);
    var byteNumbers = new Array(slice.length);

    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, {
    type: contentType
  });
}
/**
 * Декодирование в utf8
 * @param str
 */


function b64DecodeUnicode(str) {
  return decodeURIComponent(atob(str).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
}

var DocumentViewer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DocumentViewer, _React$Component);

  function DocumentViewer(props) {
    var _this;

    _classCallCheck(this, DocumentViewer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DocumentViewer).call(this, props));
    /**
     * Очистка объекта урла после загрузки iframe с pdf
     */

    _this.onLoadPdf = function () {
      URL.revokeObjectURL(_this.state.content);
    };
    /**
     * Печать документа
     */


    _this.onPrint = function () {
      var content = _this.state.content;
      var myWindow = window.open('', '', 'width = 0, height = 0');
      var pre = myWindow.document.createElement('pre');
      myWindow.document.body.appendChild(pre);
      var text = myWindow.document.createTextNode(content);
      pre.appendChild(text);
      myWindow.focus();
      myWindow.print();
      myWindow.close();
    };

    _this.state = {
      content: undefined,
      type: undefined,
      loading: true
    };
    return _this;
  }

  _createClass(DocumentViewer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          url = _this$props.url,
          transformResult = _this$props.transformResult;
      /**
       * Запрос документа
       */

      Api.get(url).pipe(map(function (result) {
        var response = result.response;

        if (transformResult) {
          return transformResult(response);
        }

        return response;
      }), catchError(function (error) {
        return throwError(error);
      })).subscribe(function (data) {
        var content;
        var type;

        try {
          type = data.mimeType.split('application/')[1];

          if (data.mimeType === 'application/pdf') {
            var blob = b64toBlob(data.doc, data.mimeType);
            content = URL.createObjectURL(blob);
          } else {
            content = b64DecodeUnicode(data.doc);
          }
        } catch (e) {
          console.error(e);

          _this2.setState({
            loading: false
          });
        }

        _this2.setState({
          loading: false,
          content: content,
          type: type
        });
      }, function (error) {
        _this2.setState({
          loading: false
        });

        console.log("\u041E\u0448\u0438\u0431\u043A\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430: ".concat(error));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state = this.state,
          content = _this$state.content,
          type = _this$state.type,
          loading = _this$state.loading;
      var _this$props2 = this.props,
          classes = _this$props2.classes,
          title = _this$props2.title,
          opened = _this$props2.opened,
          onClose = _this$props2.onClose;
      var isPdf = type === 'pdf';
      var buttons = [{
        label: 'Закрыть',
        color: 'default',
        func: this.props.onClose
      }];

      if (!isPdf && content) {
        buttons = [{
          label: 'Печать',
          icon: 'print',
          func: function func() {
            _this3.onPrint();
          }
        }].concat(_toConsumableArray(buttons));
      }

      return React.createElement(Dialog, {
        title: title || 'Просмотр документа',
        open: opened,
        disableEnforceFocus: true,
        loading: loading,
        onClose: onClose,
        buttons: loading ? [] : buttons
      }, React.createElement("div", {
        className: classes.container
      }, content && React.createElement("div", {
        className: classes.doc
      }, type === 'pdf' && React.createElement("iframe", {
        title: 'doc',
        id: 'doc',
        src: content,
        onLoad: this.onLoadPdf,
        width: '100%',
        height: '100%',
        frameBorder: '0'
      }), type !== 'pdf' && React.createElement("pre", {
        className: classes.pre
      }, content))));
    }
  }]);

  return DocumentViewer;
}(React.Component);

export default withStyles(styles, {
  name: 'DocumentViewer',
  withTheme: true
})(DocumentViewer);